import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SignalIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Signal",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16 23.429a2 2 0 1 0 0 4 2 2 0 0 0 0-4M15.976 5.668c-5.484 0-10.811 2.072-15 5.835a1.143 1.143 0 1 0 1.527 1.7c3.769-3.385 8.553-5.25 13.473-5.25 4.937 0 9.734 1.876 13.508 5.28a1.14 1.14 0 0 0 1.614-.083 1.143 1.143 0 0 0-.083-1.613c-4.195-3.786-9.536-5.87-15.039-5.87"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.989 11.81c-3.88 0-7.646 1.465-10.603 4.126a1.144 1.144 0 0 0 1.53 1.7c2.536-2.284 5.758-3.542 9.073-3.542 3.318 0 6.544 1.262 9.083 3.552a1.14 1.14 0 0 0 1.614-.083 1.143 1.143 0 0 0-.083-1.614c-2.96-2.67-6.73-4.14-10.614-4.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.994 17.938c-2.262 0-4.464.852-6.2 2.398a1.142 1.142 0 1 0 1.52 1.707c1.317-1.173 2.98-1.82 4.68-1.82 1.702 0 3.366.649 4.684 1.826a1.14 1.14 0 0 0 1.613-.092c.42-.471.38-1.194-.091-1.614-1.738-1.55-3.942-2.405-6.206-2.405Z"
    })]
  }));
};
SignalIcon.displayName = 'SignalIcon';